// NEW_FILE_JUSTIFIED: Extracts density + previewOpen state from TypeBuilderPage to keep the page under 200 lines and within the 2-useState limit
import { useState } from 'react';
import type { TBuilderDensity, IBuilderHeaderState } from '@/@types/insuranceBuilder';

export type { TBuilderDensity, IBuilderHeaderState };

export function useBuilderHeaderState(): IBuilderHeaderState {
  const [density, setDensity] = useState<TBuilderDensity>('cozy');
  const [previewOpen, setPreviewOpen] = useState(false);

  function toggleDensity() {
    setDensity(d => (d === 'compact' ? 'cozy' : 'compact'));
  }

  return { density, previewOpen, toggleDensity, setPreviewOpen };
}
